import * as React from "react";
import styled from "styled-components";
import { LinkContainer } from "components/common";
import { Badge, Nav } from "components/bootstrap";
import usePermissions from "hooks/usePermissions";
import useNotificationBadgeCount from "components/notifications/hooks/useNotificationBadgeCount";
import Routes from "routing/Routes";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import InactiveNavItem from "./InactiveNavItem";
const StyledNav = styled(Nav)`
  > li > a {
    min-height: ${NAV_ITEM_HEIGHT};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
  }
`;
const StyledInactiveNavItem = styled(InactiveNavItem)`
  a:hover {
    border: 0;
    text-decoration: none;
  }
`;
const NotificationBadge = () => {
  const { isPermitted } = usePermissions();
  const enabled = isPermitted("notifications:read");
  const { data, isLoading } = useNotificationBadgeCount({ enabled });
  return isLoading || !data ? null : /* @__PURE__ */ React.createElement(StyledNav, { navbar: true }, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.HEALTH }, /* @__PURE__ */ React.createElement(StyledInactiveNavItem, null, /* @__PURE__ */ React.createElement(Badge, { bsStyle: "danger", "data-testid": "notification-badge", title: "System Notifications" }, data))));
};
export default NotificationBadge;
